import { RegisterCopilot } from 'components/Register/RegisterCopilot';
import { RegisterFullSuite } from 'components/Register/RegisterFullSuite';
import { useRouter } from 'next/router';

const RegisterPage = () => {
  const router = useRouter();

  const { type } = router.query;

  if (type === 'copilot') {
    return <RegisterCopilot />;
  }

  return <RegisterFullSuite />;
};

export default RegisterPage;
